import { showErrorToast } from 'src/app/demo/utilities/toast-utils';
import { AvatarModule } from 'primeng/avatar';
import {
    Component,
    EventEmitter,
    inject,
    Input,
    Output,
    signal,
} from '@angular/core';
import {
    CompensationLimit,
    PresentableOption,
} from '../../../models/common-data-types';
import { CommonModule, NgIf } from '@angular/common';
import { PanelModule } from 'primeng/panel';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/demo/service/language.service';
import { languages } from 'src/app/demo/constants/languages';
import { DividerModule } from 'primeng/divider';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-insurance-option-card',
    standalone: true,
    imports: [
        CommonModule,
        PanelModule,
        AvatarModule,
        CardModule,
        ButtonModule,
        TranslateModule,
        TooltipModule,
        DividerModule,
        TranslateModule,
    ],
    templateUrl: './insurance-option-card.component.html',
    styleUrl: './insurance-option-card.component.scss',
})
export class InsuranceOptionCardComponent {
    @Input() insuranceOption!: PresentableOption;
    @Input() canBeAddedToCart!: boolean;
    @Output() removeInsuranceOption = new EventEmitter<PresentableOption>();
    @Output() addToCart = new EventEmitter<PresentableOption>();

    selectedLanguage!: any;
    languages: any = languages;

    compensationLimits: CompensationLimit[] = [];
    deductibles: CompensationLimit[] = [];
    extensions: CompensationLimit[] = [];

    blobUrl = signal<string>('');
    sanitizer = inject(DomSanitizer);

    constructor(
        private translate: TranslateService,
        private languageService: LanguageService
    ) {}

    ngAfterViewInit() {
        if (this.insuranceOption?.compensationLimits) {
            this.compensationLimits = this.insuranceOption.compensationLimits;
        }
        if (this.insuranceOption?.deductibles) {
            this.deductibles = this.insuranceOption.deductibles;
        }
        if (this.insuranceOption?.coverageExtensions) {
            this.extensions = this.insuranceOption.coverageExtensions;
        }
    }

    ngOnInit() {
        this.initializeLocale();
        this.renderProviderLogo();
    }

    renderProviderLogo() {
        if (
            this.insuranceOption.logoMimeType === 'image/png' ||
            this.insuranceOption.logoMimeType === 'image/jpeg' ||
            this.insuranceOption.logoMimeType === 'image/svg' || this.insuranceOption.logoMimeType === 'image/jpg'
        ) {
            const byteCharacters = atob(this.insuranceOption.providerLogo!);
            const byteNumbers = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const blobItem = new Blob([byteNumbers], {
                type: this.insuranceOption.logoMimeType,
            });
            this.blobUrl.set(URL.createObjectURL(blobItem));
        } else {
            
        }
    }

    initializeLocale() {
        this.languageService.currentLanguage$.subscribe((language) => {
            this.selectedLanguage = language;
            this.setLanguage(this.selectedLanguage);
        });
    }

    setLanguage(language: string) {
        this.translate.use(language);
        this.languageService.setLanguage(language);
    }

    onAddToCart(option: PresentableOption) {
        this.addToCart.emit(option);
    }

    onRemoveInsuranceOption(option: PresentableOption) {
        this.removeInsuranceOption.emit(option);
    }
}
